module.exports = __webpack_public_path__ + "static/media/logo_interdoc_FOOT.1019fb33.png";